const style = {
  dialogTitle: {
    mt: '15px',
  },
  dialogSpacing: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  dialogAction: {
    pr: '25px',
    mb: '5px',
  },
  titleBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  titleVariant: 'h5',
  closeIcon: {
    color: 'action.active',
  },
  disabledButton: {
    '&:disabled': {
      opacity: '0.34',
      backgroundColor: 'error.main',
      color: 'primary.contrast',
    },
  },
} as const;

export default style;
